export type RecyclabilityAssessmentDocumentProseCriterionKey =
  | 'a3_1'
  | 'b2_1'
  | 'b4_2'
  | 'b4_3'

export const RECYCLABILITY_ASSESSMENT_DOCUMENT_PROSE_CRITERION_REFS: Record<
  RecyclabilityAssessmentDocumentProseCriterionKey,
  string
> = {
  a3_1: 'A.3.1',
  b2_1: 'B.2.1',
  b4_2: 'B.4.2',
  b4_3: 'B.4.3',
}

export type RecyclabilityAssessmentDocumentSection3Row = {
  ref: string
  criteriaKey: string
  responseKey: string
  /** LLM-generated prose criterion id. */
  generatedProseKey?: RecyclabilityAssessmentDocumentProseCriterionKey
}

export type RecyclabilityAssessmentDocumentSection3Group = {
  groupKey: string
  titleKey: string
  rows: RecyclabilityAssessmentDocumentSection3Row[]
}

export const RECYCLABILITY_ASSESSMENT_DOCUMENT_SECTION_3_GROUPS: RecyclabilityAssessmentDocumentSection3Group[] =
  [
    {
      groupKey: 'a2',
      titleKey: 'itemDetail.recyclability.document.section3.groups.a2.title',
      rows: [
        {
          ref: 'A.2.1',
          criteriaKey:
            'itemDetail.recyclability.document.section3.criteria.a2_1',
          responseKey:
            'itemDetail.recyclability.document.section3.responses.a2_1',
        },
        {
          ref: 'A.2.2',
          criteriaKey:
            'itemDetail.recyclability.document.section3.criteria.a2_2',
          responseKey:
            'itemDetail.recyclability.document.section3.responses.a2_2',
        },
      ],
    },
    {
      groupKey: 'a3',
      titleKey: 'itemDetail.recyclability.document.section3.groups.a3.title',
      rows: [
        {
          ref: 'A.3.1',
          criteriaKey:
            'itemDetail.recyclability.document.section3.criteria.a3_1',
          responseKey:
            'itemDetail.recyclability.document.section3.responses.a3_1',
          generatedProseKey: 'a3_1',
        },
        {
          ref: 'A.3.2',
          criteriaKey:
            'itemDetail.recyclability.document.section3.criteria.a3_2',
          responseKey:
            'itemDetail.recyclability.document.section3.responses.a3_2',
        },
      ],
    },
    {
      groupKey: 'a4',
      titleKey: 'itemDetail.recyclability.document.section3.groups.a4.title',
      rows: [
        {
          ref: 'A.4',
          criteriaKey: 'itemDetail.recyclability.document.section3.criteria.a4',
          responseKey: 'itemDetail.recyclability.document.section3.responses.a4',
        },
      ],
    },
    {
      groupKey: 'b2',
      titleKey: 'itemDetail.recyclability.document.section3.groups.b2.title',
      rows: [
        {
          ref: 'B.2.1',
          criteriaKey:
            'itemDetail.recyclability.document.section3.criteria.b2_1',
          responseKey:
            'itemDetail.recyclability.document.section3.responses.b2_1',
          generatedProseKey: 'b2_1',
        },
        {
          ref: 'B.2.2',
          criteriaKey:
            'itemDetail.recyclability.document.section3.criteria.b2_2',
          responseKey:
            'itemDetail.recyclability.document.section3.responses.b2_2',
        },
      ],
    },
    {
      groupKey: 'b3',
      titleKey: 'itemDetail.recyclability.document.section3.groups.b3.title',
      rows: [
        {
          ref: 'B.3.1',
          criteriaKey:
            'itemDetail.recyclability.document.section3.criteria.b3_1',
          responseKey:
            'itemDetail.recyclability.document.section3.responses.b3_1',
        },
        {
          ref: 'B.3.2',
          criteriaKey:
            'itemDetail.recyclability.document.section3.criteria.b3_2',
          responseKey:
            'itemDetail.recyclability.document.section3.responses.b3_2',
        },
      ],
    },
    {
      groupKey: 'b4',
      titleKey: 'itemDetail.recyclability.document.section3.groups.b4.title',
      rows: [
        {
          ref: 'B.4.1',
          criteriaKey:
            'itemDetail.recyclability.document.section3.criteria.b4_1',
          responseKey:
            'itemDetail.recyclability.document.section3.responses.b4_1',
        },
        {
          ref: 'B.4.2',
          criteriaKey:
            'itemDetail.recyclability.document.section3.criteria.b4_2',
          responseKey:
            'itemDetail.recyclability.document.section3.responses.b4_2',
          generatedProseKey: 'b4_2',
        },
        {
          ref: 'B.4.3',
          criteriaKey:
            'itemDetail.recyclability.document.section3.criteria.b4_3',
          responseKey:
            'itemDetail.recyclability.document.section3.responses.b4_3',
          generatedProseKey: 'b4_3',
        },
      ],
    },
    {
      groupKey: 'b5',
      titleKey: 'itemDetail.recyclability.document.section3.groups.b5.title',
      rows: [
        {
          ref: 'B.5.1',
          criteriaKey:
            'itemDetail.recyclability.document.section3.criteria.b5_1',
          responseKey:
            'itemDetail.recyclability.document.section3.responses.b5_1',
        },
      ],
    },
  ]
